module.exports = __webpack_public_path__ + "static/img/121.dd99e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/121.png
// module id = zxgb
// module chunks = 1